import { useCallback } from "react";
import { useApiQuery, toList } from "../../useApiQuery";

export interface RealtimeTransaction {
    STORE?: string;
    STORE_NAME?: string;
    TRANSACTIONDATE?: string;
    VALIDATIONDATE?: string;
    AMOUNT?: number | string;
    RECEIPTNUMBER?: string;
    IDENTIFIER_PERSON?: string;
    [key: string]: unknown;
}

const useGetRealtimeTransactions = () => {
    const { data: realtimeTransactions, isLoading, error, fetch } = useApiQuery<RealtimeTransaction[]>(
        "/getRealtimeTransactionsPerson",
        { initialData: [], transform: toList<RealtimeTransaction> }
    );

    const getRealtimeTransactions = useCallback(
        (identifier: string | number) => fetch({ identifier }),
        [fetch]
    );

    return { realtimeTransactions, isLoading, error, getRealtimeTransactions };
};

export default useGetRealtimeTransactions;
